import i18n from '@/i18n';
const Layout = () => import('@/layouts/main.vue');
const LoyaltyPoint = () => import('./views/Index.vue');

export default [
  {
    path: '/loyalty-point',
    component: Layout,
    meta: { authRequired: true, header: true, permission: 'superadmin|marketing' },
    children: [
      {
        path: '',
        name: 'LoyaltyPoint',
        component: LoyaltyPoint,
        meta: { title: i18n.global.t('settings.loyaltyPoints') },
      },
    ],
  },
];
